export * as graduate from './graduate.jpg'
export * as peopleLaughing from './people-laughing.jpg'
